import React, { useState } from "react";
import { SidebarLayout, Icon, Card, Popup } from "@scuf/common";
import "./sidebar.scss";
import { useNavigate } from "react-router-dom";
import { RouteConstants } from "src/constants/routeConstants";
import { isDataUnityVisible } from "src/constants/constants";
import { DATA_UNITY_BASE, RBAC_BASE } from "src/router/keycloak";

const Sidebar = SidebarLayout.Sidebar;
const SidebarApp = ({ ...props }) => {
  const [expand, setExpand]: any = useState(['CamsMain']);
  const [activeName, setActivePage] = useState('Dashboard');
  const [collapsed, setCollapsed] = useState(false);
  const [helpProfile, setHelpProfile] = useState(false);
  const navigate = useNavigate();

  const handleClick = (redirectPath: string) => {
    setTimeout(() => {
      props.isSideBarOpen(false);
    }, 50);
  };


  const handleCollapse = () => {
    setCollapsed(!collapsed)
  }

  const handleItemClick = (event: any, itemProps: any) => {
    const { name } = itemProps;
    setActivePage(name);
  }

  const handleSubmenuClick = (event: any, itemProps: any) => {
    const expands: any = [...expand];
    const { name } = itemProps;
    const expanderIndex = expand.findIndex((element: any) => element === name);
    if (expanderIndex >= 0) {
      expands.splice(expanderIndex, 1);
    } else {
      expands.push(name);
    }
    setExpand(expands);
  }

  const redirectToDataUnity = (endpoint: string) => {
    window.location.href = `${DATA_UNITY_BASE}/${endpoint}`;
  }

  const handleRouting = () => {
    navigate(RouteConstants.DASHBOARD);
  }

  const handleOverview = () => {
    navigate(RouteConstants.OVERVIEW_ABSOLUTE_PATH);
  }
  const navigateToControlCenter = () => {
    console.log(RBAC_BASE)
    window.open(RBAC_BASE);
  }

  return (
    <>
      <Sidebar className={props.isOpen ? "sidebar-left-side" : "sidebar-position"}>
        <div className="sidebar-open">
          <span>
            <h4>Menu</h4>
          </span>
          <span>
            <Icon
              name="close"
              root="building"
              size="small"
              color="#000000"
              className="sidebar-close-icon"
              onClick={() => {
                props.isSideBarOpen(false);
              }}
            />
          </span>

        </div>
        <SidebarLayout.Sidebar.Submenu
          content="CAMS"
          open={(expand.indexOf("CamsMain") > -1)}
          name="CamsMain"
          onClick={handleSubmenuClick}
        >
          <Sidebar.Item
            content="Overview"
            name="CAMS-Dashboard"
            className="sidebar-item"
            onClick={handleOverview}
          />
          <Sidebar.Item
            content="All Anomalies"
            name="Anomalies"
            className="sidebar-item"
            onClick={handleRouting}
          />
        </SidebarLayout.Sidebar.Submenu>
        {isDataUnityVisible &&
          <SidebarLayout.Sidebar.Submenu
            content="Data Unity"
            open={(expand.indexOf("DataUnityMain") > -1)}
            name="DataUnityMain"
            onClick={handleSubmenuClick}
          >
            <Sidebar.Item
              content="Dashboard"
              name="Dashboard"
              onClick={(event: any, itemprops: any) => {
                redirectToDataUnity('/dashboard')
              }}
              className="sidebar-item"
            />
            <SidebarLayout.Sidebar.Submenu
              content="Onboarding"
              name="OnboardingExpander"
              onClick={handleSubmenuClick}
              open={(expand.indexOf("OnboardingExpander") > -1)}
            >
              <SidebarLayout.Sidebar.Item
                content="Connect & Collect Process"
                //activeName={activeName}
                name="AddDataSourceConnectandCollect"
                className="sidebar-item"
                onClick={(event: any, itemprops: any) => {
                  redirectToDataUnity("/onboarding/connectcollectprocess");
                  handleItemClick(event, itemprops);
                }}
              />
              <SidebarLayout.Sidebar.Item
                content="Add Data Source"
                //activeName={activeName}
                name="AddDataSource"
                className="sidebar-item"
                onClick={(event: any, itemprops: any) => {
                  redirectToDataUnity("/onboarding/adddatasource");
                  handleItemClick(event, itemprops);
                }}
              />
              <SidebarLayout.Sidebar.Item
                content="Add Analytics / Use Case"
                //activeName={activeName}
                className="sidebar-item"
                name="AddUseCaseAndAnalytics"
                onClick={(event: any, itemprops: any) => {
                  redirectToDataUnity("/onboarding/addusecaseanalytics");
                  handleItemClick(event, itemprops);
                }}
              />
              <SidebarLayout.Sidebar.Item
                content="Link Objects to Use Case"
                //activeName={activeName}
                className="sidebar-item"
                name="LinkusecasetoObjects"
                onClick={(event: any, itemprops: any) => {
                  redirectToDataUnity("/catalog/datacatalog?flg=usecasecatalog");
                  handleItemClick(event, itemprops);
                }}
              />
            </SidebarLayout.Sidebar.Submenu>
            <SidebarLayout.Sidebar.Submenu
              content="Catalog"
              // activeName={activeName}
              name="CatalogExpander"
              onClick={handleSubmenuClick}
              open={(expand.indexOf("CatalogExpander") > -1)}
            >
              <SidebarLayout.Sidebar.Item
                content="Data Catalog"
                //activeName={activeName}
                className="sidebar-item"
                name="DataCatalog"
                onClick={(event: any, itemprops: any) => {
                  redirectToDataUnity("/catalog/datacatalog");
                  handleItemClick(event, itemprops);
                }}
              />
              <SidebarLayout.Sidebar.Item
                content="Use Case Catalog"
                //activeName={activeName}
                className="sidebar-item"
                name="UseCaseCatalog"
                onClick={(event: any, itemprops: any) => {
                  redirectToDataUnity("/catalog/datacatalog?flg=usecasecatalog");
                  handleItemClick(event, itemprops);
                }}
              />
            </SidebarLayout.Sidebar.Submenu>

            <Sidebar.Item
              content="Rationalisation"
              name="Rationalisation"
              onClick={(event: any, itemprops: any) => {
                redirectToDataUnity('rationalization')
              }}
              className="sidebar-item"
            />

            <Sidebar.Item
              content="Field Mapping"
              name="Field Mapping"
              onClick={(event: any, itemprops: any) => {
                redirectToDataUnity('fieldmapping')
              }}
              className="sidebar-item"
            />

          </SidebarLayout.Sidebar.Submenu>

        }
        <Sidebar.Item
          content="Control center"
          name="Rbac"
          onClick={(event: any, itemprops: any) => {
            navigateToControlCenter()
          }}
          className="sidebar-item"
        />
        <Sidebar.Item
          content="FAQs"
          name="FAQs"
          onClick={(event: any, itemprops: any) => {
            console.log("ToDO");
          }}
          className="sidebar-item"
        />

        <Popup
          className="popup-theme-help"
          element={
            <Sidebar.Item
              content="Help"
              name="Help"
              iconRoot="building"
              onClick={() => { setHelpProfile(true) }}
              className="sidebar-item"
            />
          }
          on="click"
          open={helpProfile}
        >
          <Card className="help-card">
            <Card.Content className="help-card-content">
              <span className="help-card-content-header">
                <h3></h3>
                <Icon
                  name="close"
                  root="building"
                  size="small"
                  color="#000000"
                  className="help-close-icon"
                  onClick={() => { setHelpProfile(false); }}
                />
              </span>
              <p>For any concerns or queries, please reach out to
                <a className="help-guide-link" href="mailto:DataUnitySupport@HoneywellProd.onmicrosoft.com">
                  {"  "}
                  Honeywell Forge Data Unity Support{"  "}
                </a>{"  "}
                and we will get back to you.
              </p>
            </Card.Content>
          </Card>
        </Popup>

        <Sidebar.Item
          content="Feedback"
          name="Feedback"
          onClick={(event: any, itemprops: any) => {
            console.log("ToDO");
          }}
          className="sidebar-item"
        />
      </Sidebar>
    </>
  );
};
export default SidebarApp;
